import { Injectable, signal } from "@angular/core"

export type LogoutReason = "sessionExpired"

@Injectable({ providedIn: "root" })
export class LogoutReasonService {
  private readonly reason = signal<LogoutReason | undefined>(undefined)

  set(reason: LogoutReason): void {
    this.reason.set(reason)
  }

  consume(): LogoutReason | undefined {
    const current = this.reason()
    this.reason.set(undefined)
    return current
  }
}
